import { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SectionSidebarNav } from "@/components/SectionSidebarNav";
import { useCurrentUser, userIsBuero } from "@/lib/auth";
import {
  applyDokumenteNavActive,
  DOKUMENTE_SECTION_NAV_ITEMS,
  isDokumenteFullscreenPath,
} from "@/lib/dokumenteNav";

/**
 * Büro: Dokumente mit linker Navigation (Buchhaltung, Nachweise, Angebote, …).
 * Andere Rollen: Inhalt ohne Sektions-Sidebar (Top-Nav unverändert).
 */
export function DokumenteLayout() {
  const { user } = useCurrentUser();
  const location = useLocation();
  const isBuero = userIsBuero(user);
  const showSidebar = isBuero && !isDokumenteFullscreenPath(location.pathname);
  const navItems = useMemo(
    () => applyDokumenteNavActive(DOKUMENTE_SECTION_NAV_ITEMS, location.pathname),
    [location.pathname],
  );

  if (!showSidebar) {
    return <Outlet />;
  }

  return (
    <div className="eh-bestellwesen-page-shell">
      <SectionSidebarNav items={navItems} ariaLabel="Dokumente" />
      <div className="eh-project-page-main">
        <Outlet />
      </div>
    </div>
  );
}
